import * as L from 'leaflet';
import 'leaflet-draw';
import Basemap from './Basemap';
import EditLayer from './EditLayer';
import * as fl from 'leaflet-filelayer';
import { addGeoJSONLine } from './editFeatures';

class Editmap extends Basemap {

  editGroup;
  cnt;

  constructor(ele, opts = { center: [47.2670, 11.3920], zoom: 9 }) {
    opts.frLayers = false;
    super(ele, opts);
    this.editGroup = new EditLayer();
    this.cnt = 0;
    this.addDrawHandler();
  }

  addDrawHandler() {
    console.log('pois:  ', this.pois);
    fl(); // init FileLayer
    this.map.addLayer(this.editGroup);
    const drawControl = new L.Control.Draw({
      draw: {
        polygon: true,
        rectangle: false,
        circle: false,
        polyline: true,
        marker: {
          icon: L.divIcon({
            className: 'freerideinfo myTrack freerideinfoWarning icon-wlan'
          }),
        },
        circlemarker: false
      },
      edit: {
        featureGroup: this.editGroup,
      }
    });
    this.map.addControl(drawControl);
    const that = this;
    const gpxControl = L.Control.fileLayerLoad({
      // Allows you to use a customized version of L.geoJson.
      // For example if you are using the Proj4Leaflet leaflet plugin,
      // you can pass L.Proj.geoJson and load the files into the
      // L.Proj.GeoJson instead of the L.geoJson.
      layer: L.geoJson,
      // See http://leafletjs.com/reference.html#geojson-options
      layerOptions: {
        style: { color: 'red' },
        onEachFeature: async (ft, layer) => {
          console.log('FT/LAY: ', ft, layer);
          if (ft.type === 'Feature' && ft.geometry.type === 'LineString') {
            ft.properties.importFile = 'gpx';
            const res = await addGeoJSONLine(ft);
            console.log('done await geojson line: ', res);
            that.cnt += 1;
          }
        }
      },
      // Add to map after loading (default: true) ?
      addToMap: true,
      // File size limit in kb (default: 1024) ?
      fileSizeLimit: 1024,
      // Restrict accepted file formats (default: .geojson, .json, .kml, and .gpx) ?
      formats: [
        '.geojson',
        '.gpx',
        '.kml'
      ]
    }).addTo(this.map);
    gpxControl.loader.on('data:loaded', () => { 
      console.log('all data loaded: ', this.cnt);
      // important: do not reload, as this will kill upload rquest
      // window.location.reload();
    });
    gpxControl.loader.on('data:error', (err) => { 
      console.log('Err loading file: ', err);
      alert('Illegal file');
    });
  }

}

export default Editmap;
